import { useFormContext } from '@/contexts/form-context';
import { SalesRound } from '@/types/api/sale';
import SalesRoundListbox from './sales-round-listbox';

interface SalesRoundFormListboxProps {
  name: string;
  label: string;
  rounds: SalesRound[];
}

export default function SalesRoundFormListbox({ name, label, rounds }: SalesRoundFormListboxProps) {
  const form = useFormContext();

  return (
    <form.Field
      name={name}
      children={(field) => (
        <SalesRoundListbox
          rounds={rounds}
          onChange={field.handleChange}
          value={field.state.value as string}
          label={label}
        />
      )}
    />
  );
}
